import { Component, Input } from '@angular/core';
import { QuestionnaireModel } from 'models/generated/Entities.GormCrm.Questionnaire';
import { TranslatePipe } from 'pipes/translate.pipe';


@Component({
	selector: 'blocklist-questionnaire',
	templateUrl: './blocklist-questionnaire.component.html',
	styleUrls: ['./blocklist-questionnaire.component.scss'],
	imports: [TranslatePipe]
})
export class BlockListQuestionnaireComponent {
	
	@Input() questionnaire!: QuestionnaireModel;
	
}